import { Spinner } from '../../assets/spinners/spinner';

export interface LoaderProps {
  size: number | string;
}

export function Loader(props: LoaderProps) {
  const { size } = props;
  return (
    <div role="status">
      <Spinner width={size} height={size} />
    </div>
  );
}
